<style scoped>
.condition-select {
	font-size: 0.8rem;
	padding: 0 4px;
	height: 22px;
	width: 110px;
	border-radius: 3px;
	border: 1px solid #dee2e6;
	background: #fff;
	cursor: pointer;
}
</style>

<template>
	<select
		class="condition-select form-select form-select-sm"
		:value="modelValue"
		@change="onChange($event)"
		:style="{ borderColor: currentColor, borderWidth: '1.5px' }"
	>
		<option v-for="cond in conditions" :key="cond.value" :value="cond.value">
			{{ cond.label }}
		</option>
	</select>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { apiClient } from "@/client";

const props = defineProps<{
	modelValue: string;
	poolId?: number;
}>();

const emit = defineEmits<{
	"update:modelValue": [value: string];
}>();

const conditions = [
	{ value: "unknown", label: "unknown" },
	{ value: "blue", label: "blue" },
	{ value: "green", label: "green" },
	{ value: "dry", label: "dry" },
	{ value: "partial", label: "partial" },
	{ value: "covered", label: "covered" },
];

const CONDITION_COLORS: Record<string, string> = {
	unknown: "#facc15",
	blue: "#3b82f6",
	green: "#22c55e",
	dry: "#ef4444",
	partial: "#a855f7",
	covered: "#f97316",
	"false pool": "#6b7280",
	murky: "#78716c",
};

const currentColor = computed(
	() => CONDITION_COLORS[props.modelValue] ?? CONDITION_COLORS["unknown"],
);

async function onChange(e: Event) {
	const value = (e.target as HTMLSelectElement).value;
	emit("update:modelValue", value);
	if (props.poolId == null) return;
	try {
		await apiClient.JSONPut(
			`/api/vision/train/pool/${encodeURIComponent(props.poolId)}`,
			{ condition: value, reviewedAt: new Date().toISOString() },
		);
	} catch (e: any) {
		console.error("Failed to update pool condition:", e);
	}
}
</script>
